import React from 'react';
import Button from "./Button";
import { useFormikContext } from "formik";
import { FormValues } from "../common/FormValues";
import LoadingSpinner from "../structure/LoadingSpinner";
import { useGlobalLoadingState } from "../../App";

type NextButtonProps = {
    onClick?: (e: Event) => void,
    children?: React.ReactNode
}

const NextButton = (props: NextButtonProps) => {
    const { submitForm, isSubmitting } = useFormikContext<FormValues>()
    const loading = useGlobalLoadingState();

    return (
        <Button buttonContent={loading ? <LoadingSpinner spinnerText="Loading"/> : <span>Next</span>}
                onClick={async (event) => {
                    await submitForm()
                    props.onClick?.(event)
                }}
                buttonProps={{ disabled: (isSubmitting || loading) ? true : undefined }}
        />
    )
};
export default NextButton;